// Values used to limit the number of playlists or schedules that can be assigned to a group or zone
export const MAX_PLAYLISTS_PER_GROUP_OR_ZONE = 5
export const MAX_SCHEDULES_PER_GROUP_OR_ZONE = 10
